define('plugin/package/view/PackageInvoiceInstanceCollectionView',['require','marionette','plugin/package/view/PackageInvoiceInstanceItemView'],function (require) {

    var Marionette = require('marionette');
    var PackageInvoiceInstanceItemView = require('plugin/package/view/PackageInvoiceInstanceItemView');

    /**
     * Package invoice instance collection view
     *
     * @class PackageInvoiceInstanceCollectionView
     */
    return Marionette.CompositeView.extend({

        template: '#package_invoice_instance_list_view',
        childViewContainer: '#sb_package_instance_container',

        childView: PackageInvoiceInstanceItemView,
        childViewOptions: function (model, index) {
            return {
                usedCollection: this.model.get('package_instances'),
                serviceCollection: this.getOption('serviceCollection'),
                productCollection: this.getOption('productCollection'),
                attributeCollection: this.getOption('attributeCollection'),
                invoiceModel: this.model,
                mode: this.getOption('mode'),
                allowToEdit: this.getOption('allowToEdit'),
                isOpened: _.contains(this._visiblePackages, model.id)
            };
        },
        collectionEvents: {
            'sync': 'safeRender'
        },
        modelEvents: {
            'sync': 'safeRender'
        },
        childEvents: {
            'delete:package:instance': '_onRemovePackageInstance',
            'use:package:instance': '_onUsePackageInstance',
            'show:package:instance': '_onShowPackageInstance',
            'hide:package:instance': '_onHidePackageInstance'
        },

        _visiblePackages: null,

        initialize: function () {
            Marionette.CompositeView.prototype.initialize.apply(this);

            this._visiblePackages = this.getOption('visiblePackages');

            this.listenTo(this.getOption('serviceCollection'), 'sync', this.safeRender);
            this.listenTo(this.getOption('productCollection'), 'sync', this.safeRender);
            this.listenTo(this.getOption('attributeCollection'), 'sync', this.safeRender);
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        _onShowPackageInstance: function (data) {
            this._visiblePackages.push(data.model.id);
            this._onChangeVisiblePackages();
        },

        _onHidePackageInstance: function (data) {
            this._visiblePackages = _.without(this._visiblePackages, data.model.id);
            this._onChangeVisiblePackages();
        },

        _onChangeVisiblePackages: function () {
            this.triggerMethod('change:package:instance:visibility', this._visiblePackages);
        },

        _onUsePackageInstance: function (data) {
            this.setReadonly(true);
            this.triggerMethod('use:package:instance', this.model, data.model);
        },

        _onRemovePackageInstance: function (data) {
            this.setReadonly(true);
            this.triggerMethod('delete:package:instance', this.model, data.model);
        },

        setReadonly: function (flag) {
            this.children.each(function (view) {
                view.setReadonly(flag);
            });
        },

        filter: function (model) {
            if (!this.getOption('allowToEdit')) {
                var collection = this.model.get('package_instances');
                if (!collection || !collection.get(model.get('id'))) {
                    return false;
                }
            }
            return true;
        }

    });

});
